import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store/store.js'
import helpers from './helpers.js'
import VueAnalytics from 'vue-analytics'

import Frontpage from './views/Frontpage.vue'

import ModelList from './views/ModelList.vue'
import ModelSingle from './views/ModelSingle.vue'

import InfluencerList from './views/InfluencerList.vue'
import InfluencerSingle from './views/InfluencerSingle.vue'

import ArtistList from './views/ArtistList.vue'
import ArtistSingle from './views/ArtistSingle.vue'

import Page from './views/Page.vue'
import Login from './views/Login.vue'

import Casting from './views/Casting.vue'
import CastingViewer from './views/CastingViewer.vue'

import Catalog from './views/Catalog.vue'

import BecomeModel from './views/BecomeModel.vue'
import ModelSearch from './views/ModelSearch.vue'

import Maintenance from './views/Maintenance.vue'


// import as lazyload component: loads as async component and with a code split point
// read here: https://router.vuejs.org/guide/advanced/lazy-loading.html
//import Admin from './views/Admin.vue'
const Admin = () => import(/* webpackChunkName: "group-admin" */ './views/admin/Admin.vue')
const AdminTrashed = () => import(/* webpackChunkName: "group-admin" */ './views/admin/AdminTrashed.vue')
const AdminSettings = () => import(/* webpackChunkName: "group-admin" */ './views/admin/AdminSettings.vue')

const AdminModelList = () => import(/* webpackChunkName: "group-admin" */ './views/admin/AdminModelList.vue')
const AdminModelSingle = () => import(/* webpackChunkName: "group-admin" */ './views/admin/AdminModelSingle.vue')

const AdminPageList = () => import(/* webpackChunkName: "group-admin" */ './views/admin/AdminPageList.vue')
const AdminPageSingle = () => import(/* webpackChunkName: "group-admin" */ './views/admin/AdminPageSingle.vue')

const AdminArtistList = () => import(/* webpackChunkName: "group-admin" */ './views/admin/AdminArtistList.vue')
const AdminArtistSingle = () => import(/* webpackChunkName: "group-admin" */ './views/admin/AdminArtistSingle.vue')

const AdminInfluencerList = () => import(/* webpackChunkName: "group-admin" */ './views/admin/AdminInfluencerList.vue')
const AdminInfluencerSingle = () => import(/* webpackChunkName: "group-admin" */ './views/admin/AdminInfluencerSingle.vue')

const AdminCatalogList = () => import(/* webpackChunkName: "group-admin" */ './views/admin/AdminCatalogList.vue')
const AdminCatalogSingle = () => import(/* webpackChunkName: "group-admin" */ './views/admin/AdminCatalogSingle.vue')


function requireAuth (to, from, next) {
  
  //console.log(localStorage.getItem('scoop_loggedin_user'))

  if( store.getters.is_site_am ) {
    alert('Goto Scoop site for admin')
    return false
  }

  if( store.state.loggedin_user && store.state.loggedin_user.id ) {
    //console.log('pass')
    next()
  } else {
    //console.log('nopass')
    next('/login')
  }
  
}

// SCOOP SITE ROUTES --------------------------------------------------------------

var routes = [
  
  { name:'frontpage', path: '/', component: Frontpage, meta: { bodyClass:'page-frontpage' } },  
  
  { path: '/models', component: ModelList, meta: { bodyClass:'page-models-list', tags:{ models_list:1 } } },  
  { path: '/models/:gender/:book', component: ModelList, meta: { bodyClass:'page-models-list', tags:{ models_list:1 } } },  
  { path: '/models/:book', component: ModelList, meta: { bodyClass:'page-models-list', tags:{ models_list:1 } } },  
  
  { path: '/model/:slug', component: ModelSingle, meta: { bodyClass:'page-model-single', tags:{ model_single:1 } }},  
  { path: '/model/:slug/:book', component: ModelSingle, meta: { bodyClass:'page-model-single', tags:{ model_single:1 } } },  
  
  { path: '/model-search', component: ModelSearch, meta: { bodyClass:'page-model-search', tags:{  } } },  

  
  // scoop social pages
  { path: '/social/influencers/:category', component: InfluencerList, meta: { bodyClass:'page-influencer-list', tags:{ influencers_list:1 } } },  
  { path: '/social/influencers/:category', component: InfluencerList, meta: { bodyClass:'page-influencer-list', tags:{ influencers_list:1 } } },  

  { path: '/social/news', component: Page, meta: { bodyClass:'page page-social page-social-news', tags:{ page:1 } } },
  { path: '/social/contact', component: Page, meta: { bodyClass:'page page-social page-social-contact', tags:{ page:1 } } },
  { path: '/social/follow-us', component: Page, meta: { bodyClass:'page page-social page-social-follow-us', tags:{ page:1 } } },
  { path: '/social/location', component: Page, meta: { bodyClass:'page page-social page-social-location', tags:{ page:1 } } },
  { path: '/social/about', component: Page, meta: { bodyClass:'page page-social page-social-about', tags:{ page:1 } } },
  //{ path: '/social/micro-influencers', component: Page, meta: { bodyClass:'page page-social page-social-contact', tags:{ page:1 } } },


  { path: '/social/influencer/:slug', component: InfluencerSingle, meta: { bodyClass:'page-influencer-single', tags:{ influencer_single:1 } } },  
  { path: '/social/influencer/:slug/:book', component: InfluencerSingle, meta: { bodyClass:'page-influencer-single', tags:{ influencer_single:1 } } },  
  

  // admin pages
  { name: 'admin-home', path: '/admin', component: Admin, meta: { title:'Admin', bodyClass:'page-admin page-admin-home' }, beforeEnter: requireAuth, },  
  { name: 'admin-settings', path: '/admin/settings', component: AdminSettings, meta: { title:'Admin', bodyClass:'page-admin page-admin-settings' }, beforeEnter: requireAuth, },  
  { path: '/admin/pages',           component: AdminPageList, meta: { title:'Admin: Pages', bodyClass:'page-admin page-admin-page-list' }, beforeEnter: requireAuth, },  
  { path: '/admin/pages/:category', component: AdminPageList, meta: { title:'Admin: Pages', bodyClass:'page-admin page-admin-page-list' }, beforeEnter: requireAuth, },
  { path: '/admin/pages/:realm/:category', component: AdminPageList, meta: { title:'Admin: Pages', bodyClass:'page-admin page-admin-page-list' }, beforeEnter: requireAuth, },
  { name: 'admin-page-single', path: '/admin/page/:id', component: AdminPageSingle, meta: { title:'Admin: Page', bodyClass:'page-admin page-admin-page-single' }, beforeEnter: requireAuth, },  
  { name: 'admin-model-list', path: '/admin/models', component: AdminModelList, meta: { title:'Admin: Models', bodyClass:'page-admin page-admin-model-list' }, beforeEnter: requireAuth, },  
  { name: 'admin-model-single', path: '/admin/model/:id', component: AdminModelSingle, meta: { title:'Admin: Model', bodyClass:'page-admin page-admin-model-single' }, beforeEnter: requireAuth, },  
  { name: 'admin-artist-list', path: '/admin/artists', component: AdminArtistList, meta: { title:'Admin: Artists', bodyClass:'page-admin page-admin-artist-list' }, beforeEnter: requireAuth, },  
  { name: 'admin-artist-single', path: '/admin/artist/:id', component: AdminArtistSingle, meta: { title:'Admin: Artist', bodyClass:'page-admin page-admin-artist-single' }, beforeEnter: requireAuth, },  
  { name: 'admin-influencer-list', path: '/admin/influencers', component: AdminInfluencerList, meta: { title:'Admin: Influencers', bodyClass:'page-admin page-admin-influencer-list' }, beforeEnter: requireAuth, },  
  { name: 'admin-influencer-single', path: '/admin/influencer/:id', component: AdminInfluencerSingle, meta: { title:'Admin: Influencer', bodyClass:'page-admin page-admin-influencer-single' }, beforeEnter: requireAuth, },  
  { name: 'admin-catalog-list', path: '/admin/catalogs', component: AdminCatalogList, meta: { title:'Admin: Catalogs', bodyClass:'page-admin page-admin-catalog-list' }, beforeEnter: requireAuth, },  
  { name: 'admin-catalog-single', path: '/admin/catalog/:id', component: AdminCatalogSingle, meta: { title:'Admin: Catalog', bodyClass:'page-admin page-admin-catalog-single' }, beforeEnter: requireAuth, },  
  { name: 'admin-trashed', path: '/admin/trashed', component: AdminTrashed, meta: { title:'Admin: Trashed items', bodyClass:'page-admin page-admin-trashed' }, beforeEnter: requireAuth, },  
  
  { name: 'page-become-model', path: '/become-a-model', component: BecomeModel, meta: { title:'Become Model', bodyClass:'page page-become-model' } },  
  
  { name: 'page-login', path: '/login', component: Login, meta: { title:'Login', bodyClass:'page page-login' } },  

  { name: 'page-casting', path: '/package', component: Casting, meta: { title:'Package', bodyClass:'page page-casting' } },    
  { name: 'page-casting-view', path: '/package/:uid', component: CastingViewer, meta: { title:'Package', bodyClass:'page page-casting-view' } },

  //{ name: 'page-casting-social', path: '/social/package', component: Casting, meta: { title:'Package', bodyClass:'page page-casting' } },  
  //{ name: 'page-casting-social-view', path: '/social/package/:uid', component: CastingViewer, meta: { title:'Package', bodyClass:'page page-casting-view' } },

  { name: 'page-catalog', path: '/client/:slug', component: Catalog, meta: { title:'Client', bodyClass:'page page-catalog', tags:{ leftmenu:'empty' } } },    

  // lastly, check this one
  { path: '*', component: Page, meta: { bodyClass:'page page-generic', tags:{ page:1 } } }, 
  
]

// A-M SITE ROUTES -----------------------------------------------------------------

var routes_am = [
  
  { path: '/', component: Page, meta: { joe:666, bodyClass:'page page-frontpage-am page-generic', tags:{ page:1 } } },

  { name: 'artist-single', path: '/artist/:slug', component: ArtistSingle, 
    meta: { bodyClass:'page-artist-single', tags:{ artist_single:1 }, },
    children: [
      { path: ':book', meta:{ tags:{ artist_single:1 } }, },
    ],
  },  
  //{ name: 'artist-single', path: '/artist/:slug/:book', component: ArtistSingle, meta: { bodyClass:'page-artist-single' } },  

  { name: 'page-login', path: '/login', component: Login, meta: { bodyClass:'page page-login' } },
  { path:'/admin', redirect:'/login', },

  { name: 'page-casting', path: '/package', component: Casting, meta: { title:'Package', bodyClass:'page page-casting' } },  
  { name: 'page-casting-view', path: '/package/:uid', component: CastingViewer, meta: { title:'Package', bodyClass:'page page-casting-view' } },

  // lastly, check this one
  { path: '*', component: Page, meta: { bodyClass:'page page-generic', tags:{ page:1 } } }, 

]

//----------------------------------------------------------------------------

if( window.is_site_am == true ) {
  routes = routes_am
}

Vue.use(VueRouter)

const router = new VueRouter({
  routes,
  mode: 'history',
  saveScrollPosition: true,
  base: '/',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      window.scoop_onLoadScrollTo = savedPosition
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

router.beforeEach((to, from, next) => {  
  store.commit('onRouteChange', { to:to, from:from } )    

  if( store.state.editing_blocks ) store.commit('set_editing_blocks', false)
  //if( store.state.editing_blocks ) return next(error)
  //if( store.state.editing_blocks ) return next(false)

  next()
})


router.afterEach((to, from) => {  
    
  // If a route with a title was found, set the document (page) title to that value.
  var pagetitle = to.meta.title  
  var sitetitle = 'Scoop Models'
  if( store.getters.is_site_am ) sitetitle = 'A Management'
  if( store.getters.is_site_scoopsocial ) sitetitle = 'Scoop Social'
  var sep = ' — '
  var title = sitetitle
  if( pagetitle ) title = to.meta.title + sep + sitetitle
  document.title = title
 
  let widerContent = false
  if( store.getters.pageslug === 'news' ) widerContent = true
  if( store.getters.pageslug === 'model-search' ) widerContent = true
  //if( store.state.route.current.name === 'page-catalog' ) widerContent = true
  document.body.classList.toggle('wider-content', widerContent)

  document.body.classList.toggle('is-scoop', store.getters.is_site_scoop)
  document.documentElement.classList.toggle('is-scoop', store.getters.is_site_scoop)
  
  document.body.classList.toggle('is-am', store.getters.is_site_am)
  document.documentElement.classList.toggle('is-am', store.getters.is_site_am)
  
  document.body.classList.toggle('is-scoopsocial', store.getters.is_site_scoopsocial)
  document.documentElement.classList.toggle('is-scoopsocial', store.getters.is_site_scoopsocial)
  
  document.body.setAttribute('data-slug', store.getters.pageslug)

})




Vue.use(VueAnalytics, {
  id: window.gauaid,
  router: router,
  //ignoreRoutes: ['home', '/login'],
  _debug: {
    enabled: true,
    sendHitTask: true,
  },
  autotracking: {
    exception: true,
  },
  fields: {
    cookieDomain: 'none',
  },
})



export default router



// WEBPACK FOOTER //
// ./src/router.js